module.exports = __webpack_public_path__ + "img/mod_4.415e98ea.png";